'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, Image} from 'react-native';
import BaseInfo from '../../baseInfo/index';
import styles from './style';
import QImageSet from '../../../../../assets/QImageSet';
import { getScreenSize } from "../../../../../common/utils";

class priceCard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let flight = this.props.data || {};

        const {discount, price, arrCityBgPicUrl} = flight || {};
        const transformScale = getScreenSize().width < 360 ? styles.transformScale : {};
        return (
            <TouchableOpacity style={styles.pictureCard} onPress={()=>{this.props.jump(flight)}}>
                <Image source={{uri: arrCityBgPicUrl}} style={styles.pictureCardImg}/>
                <View style={styles.pictureCheapInfo}>
                    <BaseInfo data={flight} config={{subTitleTop: 2}}/>
                    <View style={styles.pictureCardPriceField}>
                        {discount ? <View style={[styles.pictureCardDiscount, transformScale]}>
                            <Image source={{uri: QImageSet.discount}} style={styles.pictureCardDiscountImage}/>
                            <Text style={styles.pictureCardDiscountText}>{discount}</Text>
                        </View> : null}
                        <View style={[styles.accuratePriceField, transformScale]}>
                            <Text style={[styles.priceColor, styles.picturePrefixSize]}>&yen;</Text>
                            <Text style={[styles.priceColor, styles.pictureYuanSize]}>{price}</Text>
                        </View>
                    </View>
                </View>
            </TouchableOpacity>
        )
    }
}

export default priceCard;
